import { render, staticRenderFns } from "./ActiveAccount.vue?vue&type=template&id=527b4aa2"
import script from "./ActiveAccount.vue?vue&type=script&lang=js"
export * from "./ActiveAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports